import globalTheme, { muiTheme } from '../global'

const Chip = {
	MuiChip: {
		styleOverrides: {
			deleteIcon: {
				color: globalTheme.palette.grey.main,
				fontSize: muiTheme.typography.pxToRem(12),
				margin: globalTheme.spacing(0, 0, 0, 0.625),
			},
			label: {
				paddingLeft: 0,
				paddingRight: 0,
			},
			root: {
				borderRadius: 12.5,
				fontSize: muiTheme.typography.pxToRem(12),
				height: 27,
				paddingLeft: 10,
				paddingRight: 10,
			},
		},
	},
}

export default Chip
